import { QueryClient } from "@tanstack/react-query";
import { PostHog } from "posthog-js";
import { LoaderFunctionArgs } from "react-router";
import { trpc } from "~/shared/api/core/trpc";
import { canAccessMemberSetupFlow } from "~/shared/lib/posthog/posthog.helper";
import { notFound } from "~/shared/util/notFound";

export async function participantJoinViewLoader(
  { params }: LoaderFunctionArgs,
  queryClient: QueryClient,
  posthogClient?: PostHog,
) {
  if (!canAccessMemberSetupFlow(posthogClient)) {
    return notFound();
  }

  if (!params.token) {
    return notFound();
  }

  await queryClient.ensureQueryData(trpc.public.setup.validateInvite.queryOptions({ token: params.token }));

  return null;
}
